"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
var MESSAGEAD_IDKEY = 'MessageAdKey';
exports.default = satcheljs_1.mutatorAction('populateAds', function populateAds(returnedMessageAds) {
    store_1.getStore().messageAdRowStore.clear();
    store_1.getStore().adIds = [];
    returnedMessageAds.forEach(function (returnedMessageAd, index) {
        // Use different message Ad Id key for different Ad type
        // The reason is Facebook Ad will add some special DOM when the Ad item is mounted
        // If using the same key to be swapped with another Ad type, the Facebook DOM will be kept and it causes the bad experience
        var messageAdIdKey = MESSAGEAD_IDKEY + returnedMessageAd.adType + index.toString();
        store_1.getStore().adIds.push(messageAdIdKey);
        returnedMessageAd.adId = messageAdIdKey;
        store_1.getStore().messageAdRowStore.set(messageAdIdKey, returnedMessageAd);
    });
});
//# sourceMappingURL=populateAds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-messagead-store/lib/mutators/populateAds.js
// module id = 3459
// module chunks = 17 67